"use strict";

globalThis.probe = {};
//# sourceMappingURL=init.js.map